import { useSelector } from 'react-redux';
import { Button } from 'antd';

const BottomInstructionButton = () => {
  const UsersProfile = useSelector((state) => state?.auth?.me);
  const role = useSelector(
    (state) => state?.auth?.user?.role || state?.auth?.me?.user?.roles?.[0] || state?.auth?.me?.roles?.[0],
  );
  const language = useSelector((state) => state?.auth?.language);

  if (!UsersProfile?.package?.instruction_manual_link || role !== 'merchant') {
    return null;
  }

  return (
    <Button
      type="primary"
      style={{ width: '100%' }}
      onClick={() => window.open(UsersProfile.package.instruction_manual_link, '_blank')}
    >
      {language?.content?.INSTRUCTION_MANUAL || 'Instruction manual'}
    </Button>
  );
};
export default BottomInstructionButton;
